import { apiRequest, ApiResponse } from './api';

export interface ChamadoAssunto {
  id: number;
  nome: string;
  padrao: boolean;
  categoria_id?: number | null;
  categoria?: {
    id: number;
    nome: string;
    cor: string;
  };
  createdAt: string;
  updatedAt: string;
}

class ChamadoAssuntoService {
  private baseUrl = '/chamados-assunto';

  async getAll(): Promise<ApiResponse<ChamadoAssunto[]>> {
    return apiRequest.get<ChamadoAssunto[]>(this.baseUrl);
  }

  async create(nome: string, categoria_id?: number | null): Promise<ApiResponse<ChamadoAssunto>> {
    return apiRequest.post<ChamadoAssunto>(this.baseUrl, { nome: nome.trim(), categoria_id });
  }

  async update(id: number, nome: string, categoria_id?: number | null): Promise<ApiResponse<ChamadoAssunto>> {
    return apiRequest.put<ChamadoAssunto>(`${this.baseUrl}/${id}`, { nome: nome.trim(), categoria_id });
  }

  async delete(id: number): Promise<ApiResponse<void>> {
    return apiRequest.delete(`${this.baseUrl}/${id}`);
  }
}

export const chamadoAssuntoService = new ChamadoAssuntoService();
export default chamadoAssuntoService;
